import React from "react";
import { Box, FormControl, Grid, Switch, Typography, alpha, useTheme } from "@mui/material";
import { getContactConfig } from "../../../utils/contactConfig";
import { BORDER_RADIUS_SM } from "../../../theme/theme";
import RelationshipTypeSelect from "./RelationshipTypeSelect";

interface ContactRelationshipSectionProps {
  entityType?: string;
  relationshipType: string;
  isPrimary: boolean;
  onRelationshipTypeChange: (value: string) => void;
  onPrimaryChange: (checked: boolean) => void;
}

const ContactRelationshipSection: React.FC<ContactRelationshipSectionProps> = ({
  entityType,
  relationshipType,
  isPrimary,
  onRelationshipTypeChange,
  onPrimaryChange,
}) => {
  const theme = useTheme();
  const entityRelationships = getContactConfig(entityType).relationships;

  return (
    <Box
      sx={{
        bgcolor: alpha(theme.palette.primary.main, 0.04),
        p: 2,
        borderRadius: BORDER_RADIUS_SM,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="subtitle2" fontWeight="bold" color="primary.main" gutterBottom>
        Client Relationship
      </Typography>
      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        <Grid item xs={12}>
          <RelationshipTypeSelect
            value={relationshipType}
            options={entityRelationships}
            onChange={onRelationshipTypeChange}
            size="small"
            required
            sx={{ bgcolor: "background.default" }}
            mismatchWarning={`This relationship type doesn't match the client's entity type${entityType ? ` (${entityType})` : ""}. Consider updating it.`}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="body2">Set as Primary Contact</Typography>
              <Box display="flex" alignItems="center">
                <Typography variant="caption" color="text.secondary" mr={1}>
                  {isPrimary ? "Yes" : "No"}
                </Typography>
                <Switch
                  checked={isPrimary}
                  onChange={(e) => onPrimaryChange(e.target.checked)}
                  size="small"
                />
              </Box>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
              Only one contact can be set as primary
            </Typography>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactRelationshipSection;
